import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import fetchData from "../../api/fetchApi";

export default function LearnsPage() {
  const [learns, setLearns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLearns = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchData("chaat/learns");
        setLearns(data.data || []);
      } catch (err) {
        setError(err.message || "حدث خطأ أثناء جلب البيانات");
      } finally {
        setLoading(false);
      }
    };
    fetchLearns();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد من حذف الدرس؟")) return;
    try {
      await fetchData(`chaat/learns/${id}`, "DELETE");
      setLearns(learns => learns.filter(l => l.id !== id));
    } catch (err) {
      alert(err.message || "حدث خطأ أثناء الحذف");
    }
  };

  return (
    <div className="p-6 mx-auto">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">الدروس التعليمية</h2>
        <button
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
          onClick={() => navigate("/admin/learns/new")}
        >
          إضافة درس جديد
        </button>
      </div>
      {loading && <div>جاري التحميل...</div>}
      {error && <div className="text-red-600">{error}</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {learns.map(learn => (
          <div key={learn.id} className="bg-white rounded-xl shadow p-4 flex flex-col gap-2 border">
            <div className="flex items-center gap-3">
              <img src={learn.thumbnail} alt={learn.title} className="w-20 h-20 object-cover rounded-lg" />
              <div>
                <div className="font-bold text-lg">{learn.title}</div>
                <div className="text-sm text-gray-500">{learn.category_learn?.name}</div>
                <div className="text-xs text-gray-400">{learn.created_at?.slice(0,10)}</div>
              </div>
            </div>
            <div className="flex gap-2 mt-2">
              <a href={learn.local_link} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">مشاهدة الفيديو</a>
              {learn.online_link && learn.online_link !== "online_link" && (
                <a href={learn.online_link} target="_blank" rel="noopener noreferrer" className="text-green-600 underline">رابط خارجي</a>
              )}
            </div>
            <div className="text-xs text-gray-500 mt-1">عدد المشاهدات: {learn.visit}</div>
            <div className="flex gap-2 mt-2">
              <button
                className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                onClick={() => navigate(`/admin/learns/${learn.id}/edit`)}
              >
                تعديل
              </button>
              <button
                className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition"
                onClick={() => handleDelete(learn.id)}
              >
                حذف
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
